module.exports = __webpack_public_path__ + "static/media/item_26_4.48cb5504.png";